if (!customElements.get('velouria-product-gallery')) {
  customElements.define(
    'velouria-product-gallery',
    class VelouriaProductGallery extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onThumbClick.bind(this));
      }

      onThumbClick(event) {
        const thumb = event.target.closest('.velouria-gallery-thumb');
        if (!thumb || !this.contains(thumb)) return;

        const heroImg = this.querySelector('.velouria-gallery-hero img');
        if (!heroImg) return;

        heroImg.src = thumb.dataset.fullSrc;
        heroImg.srcset = thumb.dataset.fullSrcset;
        heroImg.alt = thumb.dataset.alt || '';

        this.querySelectorAll('.velouria-gallery-thumb').forEach((btn) => {
          const isClicked = btn === thumb;
          btn.classList.toggle('is-active', isClicked);
          btn.setAttribute('aria-current', isClicked ? 'true' : 'false');
        });
      }
    }
  );
}
